import React, { useState } from "react";
import styled from "styled-components";
import logo from "../Assets/logo.png";
import useSignUp from "../hooks/useSignUp"; // Import useSignUp hook

const SignUpModal = ({ isOpen, toggleModal, onSwitchToLogin }) => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    address: "",
    contactNumber: "",
    role: "",
    password: "",
    confirmPassword: "",
  });

  // Use the custom signUp hook
  const { signUp, loading, error, success } = useSignUp();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    
    if (files.length + (formData.documents ? formData.documents.length : 0) > 5) {
      alert("You can upload a maximum of 5 files.");
      return;
    }
  
    setFormData({ ...formData, documents: files });
  };
  

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    if (formData.password !== formData.confirmPassword) {
      console.error("Passwords do not match");
      return;
    }
  
    const resetForm = () => {
      setFormData({
        fullname: "",
        email: "",
        address: "",
        contactNumber: "",
        role: "",
        password: "",
        confirmPassword: "",
        documents: [],  // ✅ Clear uploaded files
      });
    };    
  
    const response = await signUp(formData, resetForm); // ✅ Now `response` will be defined
  
    if (response && response.success) {
      console.log("Signup successful!");
    } else {
      console.error(response?.error || "Sign-up failed");
    }
  };
  
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContainer>
        <FormContainer>
          <CloseButton onClick={toggleModal}>&times;</CloseButton>
          <LogoWrapper>
            <LogoImage src={logo} alt="Ina-Ani Logo" />
          </LogoWrapper>
          <Title>CREATE NEW ACCOUNT</Title>
          <Subtitle>Welcome to Ina-Ani!</Subtitle>
          <form onSubmit={handleFormSubmit}>
          <FormRow>
          <InputContainer>
            <Input type="text" name="fullname" value={formData.fullname} onChange={handleInputChange} placeholder=" " required />
            <FloatingLabel>Name*</FloatingLabel>
          </InputContainer>
            <InputContainer>
              <Input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder=" " required />
              <FloatingLabel>Email*</FloatingLabel>
            </InputContainer>
          </FormRow>
          <FormRow>
          <InputContainer>
            <Input type="text" name="address" value={formData.address} onChange={handleInputChange} placeholder=" " required />
            <FloatingLabel>Address*</FloatingLabel>
          </InputContainer>
            <InputContainer>
              <Input type="text" name="contactNumber" value={formData.contactNumber} onChange={handleInputChange} placeholder=" " required />
              <FloatingLabel>Contact Number*</FloatingLabel>
            </InputContainer>
          </FormRow>
          <FormRow>
            <InputContainer>
              <Input type="password" name="password" value={formData.password} onChange={handleInputChange}placeholder=" " required />
              <FloatingLabel>Password*</FloatingLabel>
            </InputContainer>
            <InputContainer>
              <Input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleInputChange} placeholder=" " required />
              <FloatingLabel>Confirm Password*</FloatingLabel>
            </InputContainer>
          </FormRow>

                      <FormRow>
                      <InputContainerrole isFullWidth={["Administrator", "Farmer", "Customer"].includes(formData.role)}>
              <Dropdown name="role" value={formData.role} onChange={handleInputChange} required>
                <option value="">---</option>
                <option value="seller">Seller</option>
                <option value="customer">Customer</option>
                <option value="Administrator">Administrator</option>
              </Dropdown>
              <FloatingLabel>Role*</FloatingLabel>
            </InputContainerrole>

 </FormRow>
            {formData.role === "seller" && (
              <FormRow>
                <FileUploadContainer>
                  <Label>Upload Documents*</Label>
                  <FileInput
                    type="file"
                    name="documents"
                    onChange={handleFileChange}
                    multiple
                    required
                  />
                  {formData.documents && formData.documents.length > 0 && (
                    <FileList>
                      {formData.documents.map((file, index) => (
                        <FileItem key={index}>{file.name}</FileItem>
                      ))}
                    </FileList>
                  )}
                  </FileUploadContainer>
              </FormRow>
            )}
            <SignUpButton type="submit" disabled={loading}>
              {loading ? "Signing Up..." : "Sign Up"}
            </SignUpButton>
          </form>
          {error && <ErrorText>{error}</ErrorText>}
          {success && <SuccessText>{success}</SuccessText>}
          <SignUpPrompt>
            Already have an account?{" "}
            <SignUpLink onClick={onSwitchToLogin}>Sign in</SignUpLink>
          </SignUpPrompt>
        </FormContainer>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default SignUpModal;

// Styled Components
const ErrorText = styled.p`
  color: red;
  text-align: center;
  margin-top: 10px;
`;

const SuccessText = styled.p`
  color: green;
  text-align: center;
  margin-top: 10px;
`;
const FileList = styled.ul`
  margin-top: 10px;
  padding-left: 20px;
`;

const FileItem = styled.li`
  font-size: 14px;
  color: #333;
`;

const ModalOverlay = styled.div`
 position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  width: 450px;
  padding: 2rem;
  position: relative;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;
const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;

const LogoWrapper = styled.div`
  text-align: center;
  margin-bottom: .5rem;
  width: 30px;
  height: 30px;
`;

const LogoImage = styled.img`
  width: 60px;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #333333;
  margin-bottom: 0.3rem;
`;

const Subtitle = styled.p`
  font-size: 0.95rem;
  color: #666666;
  margin-bottom: 0.5rem;
`;

const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem; /* Ensures spacing between elements */

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;


const InputContainer = styled.div`
  position: relative;
 width: ${({ isFullWidth }) => (isFullWidth ? "110%" : "46%")}; /* Full width for specific roles */
  margin-bottom: 1rem; /* Adds spacing below each box */

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const InputContainerrole = styled.div`
  position: relative;
  flex: ${({ isFullWidth }) => (isFullWidth ? "0 0 105%" : "0 0 51%")};
  margin-bottom: 1rem;
  border: 1px;
  
  @media (max-width: 768px) {
    flex: 0 0 100%;
  }
`;
const FileUploadContainer = styled.div`
  position: relative;
  top: -70px;        
  left: 150px;        
  margin-top: 10px;
  margin-left: 3px;
  border: 1px ;
  border-radius: 5px;

  @media (max-width: 768px) {
    top: 0;
    left: 0;
  }
`;


const FileInput = styled.input`
  position: relative;
  top: -20px;         
  left: 70px;       
  width: 100%;
  padding: 0.7rem 10px;
  border: none;     /* Remove inner border */
  border-radius: 5px;
  font-size: 0.95rem;
  background: transparent;
  margin-top: 0.5rem;

  @media (max-width: 768px) {
    top: 0;
    left: 0;
  }
`;


const FloatingLabel = styled.label`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 0.95rem;
  color: #008000;
  transition: all 0.2s ease-in-out;
  pointer-events: none;
  background: white;
  padding: 0 5px;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.7rem 10px;
  border: 1px solid #008000;
  border-radius: 5px;
  font-size: 0.95rem;
  background: transparent;

  &:focus + ${FloatingLabel},
  &:not(:placeholder-shown) + ${FloatingLabel} {
    top: 5px;
    font-size: 0.75rem;
    color: #006600;
  }
`;

const Dropdown = styled.select`
  width: 100%;
  padding: 0.7rem 10px;
  border: 1px solid #008000;
  border-radius: 5px;
  font-size: 0.95rem;
  background: transparent;
  appearance: none;
  cursor: pointer;

  &:focus + ${FloatingLabel},
  &:not([value=""]) + ${FloatingLabel} {
    top: 5px;
    font-size: 0.75rem;
    color: #006600;
  }
`;

const Label = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color:rgb(51, 51, 51);
`;

const SignUpButton = styled.button`
  background: #008000;
  color: white;
  padding: 0.8rem 2rem;
  border: none;
  border-radius: 25px;
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  margin: 0 auto;
  display: block;

  &:hover {
    background: #006600;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  color: #999999;
  font-size: 1.5rem;
  cursor: pointer;

  &:hover {
    color: #004d00;
  }
`;

const SignUpPrompt = styled.div`
  margin-top: 1rem;
  font-size: 0.85rem;
`;

const SignUpLink = styled.a`
  color: #008000;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

